import { DBEntity } from './db-entity.model';
import { MediaFile } from './media-file.model';
import { Product } from './product.interface';

export interface ThirdParty extends DBEntity {
  code: string;
  status: string;
  contact_details: Contact;
}

export interface Contact extends Omit<DBEntity, 'name'> {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  url?: string;
  address_details?: Address;
}

export interface Address {
  address?: string;
  zip_code?: number;
  city?: string;
  state?: string;
  country?: string;
  region?: string;
}

export interface ThirdPartyFullObject {
  id: number;
  first_name?: string;
  last_name?: string;
  email: string;
  created_at: string;
  updated_at: string;
  email_verified_at: string | null;
  is_verified: number;
  status: string;
  allow_2fa: boolean;
  groups: any[];
  roles: any[];
  custom_fields: any[];
  permissions: Permission[];
  supervisor?: any | null;
  is_employee: boolean;
  date_of_birth: string | null;
  phone_number: string;
  claim_payout_limit: number | null;
  gap_claim_payout_limit: number | null;
  required_forms: RequiredForm[];
  answers: Answer[];
  avatar?: { url: string }[];
  created_by: CreatedBy;
  department: any | null;
  third_party_info?: ThirdPartyInfo;
  has_reinsurance: number;
  has_rate_structure: number;
  shared_documents?: MediaFile[];
  parent?: ThirdPartyFullObject;
  dealer_group_users?: ThirdPartyFullObject[];
  approval_emails?: string[];
}

export interface Permission {
  id: number;
  name: string;
  title: string;
}

export interface RequiredForm {
  id: number;
  title: string;
  is_completed: number;
  is_verified: number;
  version: number;
}

export interface CreatedBy {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  created_at: string;
  updated_at: string;
  email_verified_at: string | null;
  is_verified: number;
  status: string;
  allow_2fa: boolean;
  is_employee: boolean;
  date_of_birth: string | null;
  phone_number: string;
  claim_payout_limit: number | null;
  gap_claim_payout_limit: number | null;
  avatar: string[];
  has_reinsurance: number;
  has_rate_structure: number;
}

export interface ContactDetails {
  first_name: string;
  last_name: string;
  middle_name: string | null;
  spouse: string | null;
  email: string;
  phone: string;
  label: string | null;
  url: string | null;
  address_details?: Address;
}

export interface ThirdPartyInfo {
  id: number;
  name: string;
  third_party_name?: string;
  code: string;
  status: string;
  contact_details: ContactDetails;
  created_at: string;
  products: Product[];
  internal_code: number | null;
  company_name?: string;
}

export interface Answer {
  id: number;
  boarding_form: BoardingForm;
  version: number;
  answers: AnswerObject[];
  created_at: string;
}

export interface BoardingForm {
  id: number;
  client: string;
  title: string;
  created_at: string;
  sent_to_users: number;
  fields: Field[];
}

export interface Field {
  id: number;
  content?: string | Content;
  type: string;
  options: AnswerOption[];
  order: number;
  is_required: number;
  notes_count?: number;
  list_model?: string;
}

export interface Content {
  id: number;
  file_name: string;
  size: string;
  name: string;
  created_at: string;
  url: string;
  properties: any[];
}

export interface AnswerObject {
  id: number;
  field?: any;
  simple_answer?: string;
  options: AnswerOption[];
  signature: any[];
  model?: any;
  models: any[];
}

export interface AnswerOption {
  id: number;
  option: string;
}
